import { render, staticRenderFns } from "./AAsignacionNegoUnidadV2.vue?vue&type=template&id=32364d7f&scoped=true"
import script from "./AAsignacionNegoUnidadV2.vue?vue&type=script&lang=js"
export * from "./AAsignacionNegoUnidadV2.vue?vue&type=script&lang=js"
import style0 from "./AAsignacionNegoUnidadV2.vue?vue&type=style&index=0&id=32364d7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32364d7f",
  null
  
)

export default component.exports